import jsonStates from "@/config/states.json";

/**
 * Remove non-lending / cp_blocked states from a state option list.
 * Supports jsonStates shape ({ id }) and select shape ({ code } | { value }).
 */
export function filterNonLendingStates(allStates, nonLendingStates = []) {
  if (!Array.isArray(nonLendingStates) || nonLendingStates.length === 0) {
    return allStates;
  }

  const blocked = new Set(nonLendingStates.map((s) => String(s).toUpperCase()));

  return allStates.filter((state) => {
    const code = (state.id || state.code || state.value || "").toUpperCase();
    return code && !blocked.has(code);
  });
}

export const allStates = jsonStates;

export function getLendingStates(nonLendingStates) {
  return filterNonLendingStates(allStates, nonLendingStates);
}
